export const Status = ['SaisieAdherent', 'EnCoursDeTransmission'] as const

export type Statut = (typeof Status)[number]

export const StatutLibelle: Record<Statut, string> = {
  SaisieAdherent: 'En cours de saisie adhérent',
  EnCoursDeTransmission: 'En cours de transmission',
}

export const StatutBadgeType: Record<Statut, string> = {
  SaisieAdherent: 'info',
  EnCoursDeTransmission: 'success',
}
